import React, { createContext } from "react";
import ModalContextInterface from "./types";

const ModalContext = createContext<ModalContextInterface>({
  isOpen: false,
  modalChildren: <div />,
  openModal: () => {},
  closeModal: () => {},
  modalTitle: "",
});

export default ModalContext;
